import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

export const ThemeListContext = createContext(
  {},
);

export const ThemeListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      committee: undefined,
      keyword: '',
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions(oldValue => ({
      ...oldValue,
      filterParams: params
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions(oldValue => ({
      ...oldValue,
      pagination: paginationOption
    }));
  }, []);

  return (
    <ThemeListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </ThemeListContext.Provider>
  );
};

export function useThemeList() {
  const context = useContext(ThemeListContext);

  if (!context) {
    throw new Error('useThemeList must be used within an ThemeListProvider.');
  }

  return context;
}
